import {
    // FILE_UPLOAD,
    CREATE_SJFGENERAL,
    RETRIEVE_SJFGENERAL,
    UPDATE_SJFGENERAL,
    DELETE_SJFGENERAL,
    RETRIEVESINGLE_SJFGENERAL,
} from "./type";
import SJFGeneral from "../service/sjfGeneral";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFGeneral.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFGeneral.create(data);
        dispatch({
            type: CREATE_SJFGENERAL,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFGeneral.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFGENERAL,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFGeneral.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFGENERAL,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFGeneral.update(data);
        dispatch({
            type: UPDATE_SJFGENERAL,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFGeneral.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFGENERAL,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFGeneral.trash(data);
        dispatch({
            type: DELETE_SJFGENERAL,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};